import React from "react";
import Layout from "../components/Layout/Layout";

const Success = () => {
  return (
    <Layout>
      <div className="text-center">Payment Successful</div>
    </Layout>
  );
};

export default Success;
